import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import StatusBadge from '../common/StatusBadge';
import AgendaItemsList from './AgendaItemsList';

const AgendaCard = ({ agenda, isExpanded, onToggle, triggers }) => {
  return (
    <div className="border rounded-lg overflow-hidden">
      <div className="p-4 cursor-pointer flex justify-between items-center bg-purple-50" onClick={() => onToggle(agenda.id)}>
        <div className="flex-grow">
          <div className="flex items-center">
            <span className="text-sm font-medium text-gray-900">{agenda.title}</span>
            <span className="ml-3">
              <StatusBadge status={agenda.status} />
            </span>
          </div>
          <div className="text-xs text-gray-500 mt-1 flex items-center">
            <span>{agenda.date}</span>
            <span className="mx-2">•</span>
            <span>{agenda.duration}</span>
            <span className="mx-2">•</span>
            <span>{agenda.format}</span>
          </div>
        </div>
        <div>
          {isExpanded ? <ChevronUp size={18} className="text-gray-500" /> : <ChevronDown size={18} className="text-gray-500" />}
        </div>
      </div>
      
      {isExpanded && (
        <div className="p-4 bg-white border-t border-gray-100">
          <div className="mb-4">
            <h4 className="text-sm font-medium text-gray-700 mb-2">Generated from:</h4>
            <div className="flex flex-wrap gap-2">
              {agenda.generatedFrom.map((source, index) => (
                <span key={index} className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                  {source}
                </span>
              ))}
            </div>
          </div>
          
          <h4 className="text-sm font-medium text-gray-700 mb-2">Agenda Items:</h4>
          <AgendaItemsList items={agenda.items} triggers={triggers} />
          
          <div className="bg-gray-50 p-3 rounded-md mb-4">
            <h4 className="text-sm font-medium text-gray-700 mb-2">Preparation Notes:</h4>
            <ul className="list-disc pl-5 text-sm text-gray-600">
              {agenda.preparationNotes.map((note, index) => (
                <li key={index}>{note}</li>
              ))}
            </ul>
          </div>
          
          <div className="mb-4">
            <h4 className="text-sm font-medium text-gray-700 mb-2">Client Preferences:</h4>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              <div className="bg-purple-50 p-2 rounded">
                <p className="text-xs font-medium text-purple-800">Communication Style</p>
                <p className="text-sm">{agenda.clientPreferences.communicationStyle}</p>
              </div>
              <div className="bg-purple-50 p-2 rounded">
                <p className="text-xs font-medium text-purple-800">Meeting Pace</p>
                <p className="text-sm">{agenda.clientPreferences.meetingPace}</p>
              </div>
              <div className="bg-purple-50 p-2 rounded">
                <p className="text-xs font-medium text-purple-800">Decision Making</p>
                <p className="text-sm">{agenda.clientPreferences.decisionMaking}</p>
              </div>
            </div>
          </div>
          
          <div className="flex justify-between mt-4">
            <button className="px-3 py-1.5 bg-white border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50">
              Edit Agenda
            </button>
            <div className="flex space-x-2">
              <button className="px-3 py-1.5 bg-white border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50">
                Share with Team
              </button>
              <button className="px-3 py-1.5 bg-purple-600 rounded-md text-sm font-medium text-white hover:bg-purple-700">
                Finalize Agenda
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AgendaCard;